<template>
  <div>
    <GameSliderPage v-if="listType === 'slider'" :is-enable-large-banner="isEnableLargeBanner" />
    <GameListScrollPage v-else-if="listType === 'scroll'" :is-enable-large-banner="isEnableLargeBanner" />
    <GameListPage v-else-if="listType === 'list'" :is-enable-large-banner="isEnableLargeBanner" />
    <GameSliderPage v-else :is-enable-large-banner="isEnableLargeBanner" />
    <HR18Alert />
    <OverlayAd
      v-if="overlayEnable"
      :overlay-ads="overlayAds"
      :image-url="imageUrl"
      :query-string="queryString"
    />
  </div>
</template>

<script>
import { configurationLocale } from '@/utils/navigation'
import HR18Alert from '@/components/HR18Alert.vue'
import OverlayAd from '@/components/OverlayAd.vue'
import { getCloudStorage } from '@/plugin/axios'
import qs from 'qs'
import GameSliderPage from './GameSliderPage.vue'
import GameListScrollPage from './GameListScrollPage.vue'
import GameListPage from './GameListPage.vue'

import '@/assets/css/main.scss'

export default {
  name: 'HomePage',
  components: {
    HR18Alert,
    OverlayAd,
    GameListScrollPage,
    GameSliderPage,
    GameListPage
  },
  data() {
    return {
      queryString: '',
      showMenu: false,
      configData: {},
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      listType: 'scroll'
    }
  },
  async created() {
    const location = window.location.href
    const index = location.indexOf('?')

    this.queryString = index > -1 ? location.slice(index + 1) : ''
    const query = index > -1 ? qs.parse(this.queryString) : {}
    const filename = query.utm_source ? query.utm_source : 'default'

    // 設置列表類型
    if (query.list === 'slider')
      this.listType = 'slider'
    else if (query.list === 'scroll')
      this.listType = 'scroll'
    else if (query.list === 'list')
      this.listType = 'list'
    else
      this.listType = 'scroll'

    let url = encodeURIComponent(`config/minisite/${filename}.json`)
    try {
      const timestamp = Math.floor(Date.now() / (5 * 600))
      console.log('🌐 HomePage Request:', {
        url: url,
        fullUrl: `${process.env.VUE_APP_CLOUD_STORAGE_URL}/storage/v1/b/h365-landing-page/o/${url}`,
        params: { alt: 'media', t: timestamp },
        method: 'GET'
      })

      const { data } = await getCloudStorage.get(url,
        { params: { alt: 'media', t: timestamp } })
      if (data) this.configData = data
      if (this.$i18n.messages[configurationLocale(data?.lang)])
        this.$i18n.locale = configurationLocale(data?.lang)
    }
    catch (error) {
      console.error('❌ HomePage Error:', error)
      url = encodeURIComponent('config/minisite/default.json')

      const timestamp = Math.floor(Date.now() / (5 * 600))
      console.log('🔄 HomePage Fallback Request:', {
        url: url,
        fullUrl: `${process.env.VUE_APP_CLOUD_STORAGE_URL}/storage/v1/b/h365-landing-page/o/${url}`,
        params: { alt: 'media', t: timestamp },
        method: 'GET'
      })

      const { data } = await getCloudStorage.get(url,
        { params: { alt: 'media', t: timestamp } })
      if (data) this.configData = data
    }
  },
  computed: {
    games() {
      if (this.configData?.games && this.configData.games.length > 0) {
        const width = this.getDeviceType() === 'desktop' ? 256 : 384
        return this.configData.games
          .map(item => {
            item.image = `${width}/${this.imagePath}/${item.image}`
            return item
          })
      }
      return []
    },
    slides() {
      if (this.configData?.slides && this.configData.slides.length > 0) {
        const width = this.getDeviceType() === 'desktop' ? 1360 : 428
        return this.configData.slides
          .map(item => {
            item.image = `${width}/${this.imagePath}/${item.image}`
            return item
          })
      }
      return []
    },
    backgroundLink() {
      if (this.configData?.backgroundLink)
        return this.configData.backgroundLink
      return ''
    },
    backgroundImage() {
      if (this.configData?.backgroundImage) {
        const width = this.getDeviceType() === 'desktop' ? 1920 : 0
        if (width === 0) return ''
        const image = this.configData.backgroundImage
        return `${width}/${this.imagePath}/${image}`
      }
      return ''
    },
    h365Url() {
      if (this.configData?.logoURL)
        return this.configData.logoURL
      return ''
    },
    imageUrl() {
      if (process.env.VUE_APP_IMAGE_URL)
        return process.env.VUE_APP_IMAGE_URL
      return ''
    },
    imagePath() {
      if (process.env.VUE_APP_IMAGE_PATH)
        return process.env.VUE_APP_IMAGE_PATH
      return ''
    },
    hiddenHeader() {
      if (this.configData?.hiddenHeader)
        return this.configData.hiddenHeader
      return false
    },
    hiddenFooter() {
      if (this.configData?.hiddenFooter)
        return this.configData.hiddenFooter
      return false
    },
    hiddenContactUs() {
      if (this.configData?.hiddenContactUs)
        return this.configData.hiddenContactUs
      return false
    },
    hiddenFAQ() {
      if (this.configData?.hiddenFAQ)
        return this.configData.hiddenFAQ
      return false
    },
    hiddenPrivacyPolicy() {
      if (this.configData?.hiddenPrivacyPolicy)
        return this.configData.hiddenPrivacyPolicy
      return false
    },
    enableMenu() {
      if (this.configData?.enableMenu !== undefined)
        return this.configData.enableMenu
      return true
    },
    langMap() {
      if (this.$i18n.locale === 'zh-CN')
        return ''
      return `/${this.$i18n.locale}`
    },
    logoImage() {
      const width = this.getDeviceType() === 'desktop' ? 140 : 119
      return `${width}/${this.imagePath}/h365-logo-reverse.png`
    },
    overlayAds() {
      if (this.configData?.overlayAdvertisements && this.configData.overlayAdvertisements.length > 0) {
        const width = this.getDeviceType() === 'desktop' ? 1360 : 428
        return this.configData.overlayAdvertisements.map(item => ({
          ...item,
          // 使用与其他图片相同的相对路径格式
          image: `${width}/${this.imagePath}/${item.image}`
        }))
      }
      return []
    },
    isEnableLargeBanner() {
      const location = window.location.href
      const index = location.indexOf('?')
      if (index > -1) {
        const query = qs.parse(location.slice(index + 1))
        // 檢查 isEnableLargeBanner 參數，支持 'false', '0', 'no' 等值來禁用
        if (query.isEnableLargeBanner === 'false' || query.isEnableLargeBanner === '0' || query.isEnableLargeBanner === 'no')
          return false
      }
      return true // 預設啟用
    },
    overlayEnable() {
      const location = window.location.href
      const index = location.indexOf('?')
      if (index > -1) {
        const query = qs.parse(location.slice(index + 1))
        // 檢查 overlayEnable 參數，支持 'true', '1', 'yes' 等值，默認為 true
        if (query.overlayEnable === 'false' || query.overlayEnable === '0' || query.overlayEnable === 'no')
          return false
      }
      return true // 默認啟用 overlay
    }
  },
  methods: {
    getDeviceType() {
      const width = document.body.getBoundingClientRect().width
      if (width <= 768) return 'mobile'
      if (width > 1024) return 'desktop'
      return 'tablet'
    }
  }
}
</script>

<style lang="scss" scoped>
.homepage {
  background-color: #1c1c1c;
  min-height: 100vh;

  .game-card-contant {
    background-color: #1c1c1c;
    position: relative;
    width: 100%;
  }

  .header {
    background-color: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    color: #222;
    .header-container, .logo, .main-nav, .menu_btn {
      color: #222;
      fill: #222;
    }
    .custom-navbar {
      color: #222 !important;
    }
  }

  .footer {
    background-color: #fff;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    color: #222;
    .footer-txt, .copyright {
      color: #222;
    }
    .footer-logo img {
      filter: none;
    }
  }

  .game-list-slider {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 40px 40px 40px;
    .game-grid {
      gap: 60px 50px;
    }
  }
  .game-list-scroll {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 40px 40px 40px;
    .game-grid {
      gap: 60px 50px;
    }
  }
}

@media (max-width: 768px) {
  .homepage {
    .game-list-slider,
    .game-list-scroll {
      padding: 0 25px 25px 25px;
      .game-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 40px 30px;
      }
    }
  }
}

@media (max-width: 480px) {
  .homepage {
    .game-list-slider,
    .game-list-scroll {
      padding: 0 15px 20px 15px;
      .game-grid {
        gap: 25px 20px;
      }
    }
  }
}
</style>